export const inquiryOptions = [
  { value: "Provider", label: "Provider" },
  { value: "Customer", label: "Customer" },
  { value: "FuneralDirector", label: "Funeral Director" },
  { value: "GriefCounselor", label: "Grief Counselor" },
  { value: "InsuranceProvider", label: "Insurance Provider" },
  { value: "LegalRepresentative", label: "Legal Representative" },
  { value: "Others", label: "Others" },
];

export const reasonForInquiryOptions = [
  { value: "GeneralEnquiry", label: "General Enquiry" },
  { value: "PartnerWithUs", label: "Partner With Us" },
  { value: "CustomerEnquiry", label: "Customer Enquiry" },
  { value: "VendorsAndSupplierEnquiry", label: "Vendors And Supplier Enquiry" },
  { value: "GriefSupport", label: "Grief Support" },
  { value: "InsuranceHelp", label: "Insurance Help" },
  { value: "LegalHelp", label: "Legal Help" },
  { value: "Others", label: "Others" },
];